import styled from 'styled-components';
import { getResponsiveStyles } from '../get-responsive-styles.js';
import {} from './index.js';
import { getMargins } from '@oneaudi/unified-web-alpha-common';
export const StyledLayoutItem = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  ${(props) => getResponsiveStyles({
    'align-self': props.align,
    'flex-basis': props.basis,
    'flex-grow': props.grow,
    'flex-shrink': props.shrink
})}
`;
//# sourceMappingURL=index.styles.js.map